import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/general/Topbar";
import SmuBreadcrumbs from "../../utils/smu-breadcrumbs/SmuBreadcrumbs";

const UserLayout = () => {
  return (
    <div className="w-100 d-flex smu-bg-body">
      <Sidebar />

      <Container fluid className="smu-container scroll-container px-0">
        <Topbar />

        <Container fluid className="py-3 px-0 px-lg-3">
          <Row>
            <Col col={12} className="col-12">
              <SmuBreadcrumbs />
            </Col>
          </Row>
          <Outlet />
        </Container>
      </Container>
    </div>
  );
};

export default UserLayout;
